'use strict';

const SELECTORS = {
    levels: '.accordion-block__item',
    levelButton: '.membership-levels__button',
    form: '.membership-levels__form',
    selectedLevel: '.membership-levels__selected-level',
    sticky: '.membership-levels__sticky',
};

export function init() {
    const levelEls = document.querySelectorAll(SELECTORS.levels);
    const target = document.querySelector(SELECTORS.sticky);

    if (!target) {
        return;
    }

    levelEls.forEach(element => {
        const button = element.querySelector(SELECTORS.levelButton);

        if (!button) {
            console.warn('Button not found in element', element);
            return;
        }

        const form = target.querySelector(SELECTORS.form);
        const visibleClass = 'is-toggled';

        button.addEventListener('click', () => {
            target.classList.add(visibleClass);
            target.querySelector(SELECTORS.selectedLevel).innerText = button.dataset.levelTitle;

            form.amount.value = button.dataset.minimumDonation;
            form.amount.focus();
        }, false);
    });

    document.querySelectorAll(SELECTORS.form).forEach(form => {
        form.addEventListener('submit', event => {
            event.preventDefault();

            window.location.href = decodeURI(event.target.action).replace('{amount}', event.target.amount.value);
        });
    });
}
